import useSWR from "swr"

export default function useSortedGraph(ticker, dataset, column, privateCompany, open = true, group='', endDate='') { //endDate - format yyyy-mm-dd
    const { data: layer } = useSWR(open && ticker && dataset && column && `/api/getSortedGraphData?ticker=${ticker}&dataset=${dataset}&column=${column}&private=${privateCompany}&group=${group}&end_date=${endDate}`)

    return {
        layer
    }
}